import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { isEmpty, get } from 'lodash';

import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';

import { PrivateRoute } from '../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../constants/permission';

// const PlatformVariableMapping = asyncRoute(() => import('./PlatformVariableMapping'));
const DspPlatform = asyncRoute(() => import('./DspPlatform'));
// const TenantAdvertiser = asyncRoute(() => import('./TenatAdvertiser'));
const Varibles = asyncRoute(() => import('./Variables'))

const DataConfig = (props) => {

    return (<Switch>
        <Route exact path={`${props.match.path}`} render={() => <Redirect to={`${props.match.path}/${routes.dataConfig.dspPlatform.name}`} />} />


        {/* <Route path={`${props.match.path}/${routes.dataConfig.platformVaraible.name}`} component={PlatformVariableMapping}
            // permissions={MODULE_PERMISSIONS.AUDIENCE_HIERARCHY}
            defaultRoute={'dataConfig'} /> */}


        <Route path={`${props.match.path}/${routes.dataConfig.dspPlatform.name}`} component={DspPlatform}
            // permissions={MODULE_PERMISSIONS.AUDIENCE_HIERARCHYMANAGER}
            defaultRoute={'dataConfig'} />

        {/* <Route path={`${props.match.path}/${routes.dataConfig.platformTenantAdvertiser.name}`} component={TenantAdvertiser}
            // permissions={MODULE_PERMISSIONS.AUDIENCE_TAXONOMYMANAGER}
            defaultRoute={'dataConfig'} /> */}


        <Route path={`${props.match.path}/${routes.dataConfig.variables.name}`} component={Varibles}
            // permissions={MODULE_PERMISSIONS.AUDIENCE_DATACAPTURE}
            defaultRoute={'audience'} /> 


    </Switch>
    );
}

export default DataConfig;
